import React, {PropTypes} from 'react';
import EntryPaymentLogContainer from './EntryPaymentLogContainer.jsx';
import DisplayIf from 'shared/DisplayIf';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const BalanceDetail = ({
  balance,
  showPaymentLog,
  isCancelled,
  onPaymentLogClick,
  onEntryDetailPaymentClick,
  onEntryDetailCreditCardPaymentClick,
  onRefundClick,
  enabledWebHooks,
  onWebHooksClick,
  environment
}) => (
  <div>
    <div className="panel panel-primary">
      <div className="panel-heading"
        style={{paddingTop: 15}}>
        <div className="row flex vertical-center">
          <div className="col-xs-2"
            style={{marginTop: 5}}>
            <h1 className="panel-title">Team Balance</h1>
          </div>
          <div className="col-xs-3"
            style={{marginTop: 5}}>
            <h3 className="panel-title">{`$${balance.formatCurrency(2)}`}</h3>
          </div>
          <div className="col-md-7 flex vertical-center right"
            style={{marginTop: 5}}>
            <button
              style={{fontSize: 18, minWidth: 150, marginLeft: 10}}
              className="btn btn-link"
              type="button"
              onClick={() => onPaymentLogClick()}>
              {'Payment Log'}
            </button>
            <button
                style={{mindWidth: 150, marginLeft: 10}}
                className="btn btn-default btn-lg"
                type="button"
                onClick={() => onRefundClick()}>
                {'Refund'}
            </button>
            <DisplayIf condition={!!balance && !isCancelled}>
              <button
                style={{minWidth: 150, marginLeft: 10}}
                className="btn btn-default btn-lg"
                type="button"
                onClick={() => onEntryDetailPaymentClick()}>
                {'Cash/Check'}
              </button>
              <button
                style={{minWidth: 150, marginLeft: 10}}
                className="btn btn-primary btn-lg"
                type="button"
                onClick={() => onEntryDetailCreditCardPaymentClick()}>
                  {'Credit Card'}
              </button>
            </DisplayIf>
          </div>
        </div>
      </div>
      <div className="panel-body" 
        style={{ padding: 0 }}>
        <DisplayIf condition={!!balance && !isCancelled && (environment != 'PROD' && environment != 'PRODUCTION')} 
          className="custom-checkbox-container" 
          style={{ float: "right", paddingRight: 15 }}>
          <input type="checkbox"
            id="webHooks"
            checked={enabledWebHooks}
            onChange={event => onWebHooksClick(event.target.checked)}/>
          <label htmlFor="webHooks">
            Click here to process payments in real time.
          </label>
        </DisplayIf> 
      </div>
    </div>
    {showPaymentLog
      ? <div className="animated fadeIn">
          <EntryPaymentLogContainer />
        </div>
      : null
    }
  </div>
);

BalanceDetail.propTypes = {
  balance: PropTypes.number,
  showPaymentLog: PropTypes.bool,
  isCancelled: PropTypes.bool,
  onPaymentLogClick: PropTypes.func,
  onEntryDetailPaymentClick: PropTypes.func,
  onEntryDetailCreditCardPaymentClick: PropTypes.func,
  onRefundClick: PropTypes.func,
  enabledWebHooks: PropTypes.bool,
  onWebHooksClick: PropTypes.func,
  environment: PropTypes.string
};

BalanceDetail.defaultProps = {
  balance: 0,
  showPaymentLog: false,
  isCancelled: false
};

export default BalanceDetail;



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/BalanceDetail.jsx